// extracted by mini-css-extract-plugin
export default {"activePowerTable":"ElectricityBillDNEActivePower_activePowerTable__yibQb"};